import React from 'react';
import { Route, IndexRoute } from 'react-router';

// NOTE: here we're making use of the `resolve.root` configuration
// option in webpack, which allows us to specify import paths as if
// they were from the root of the ~/src directory. This makes it
// very easy to navigate to files regardless of how deeply nested
// your current file is.
import CoreLayout from 'layouts/CoreLayout/CoreLayout';
import SearchUnitStandaloneLayout from 'layouts/SearchUnitStandaloneLayout/SearchUnitStandaloneLayout';
import SearchUnitStandaloneHotelLayout from 'layouts/SearchUnitStandaloneHotelLayout/SearchUnitStandaloneHotelLayout';

import { activate } from 'utils/optimizely';

export default (
  <Route path="/" component={CoreLayout} onEnter={activate}>
    <Route path="hotels*" component={SearchUnitStandaloneHotelLayout} />
    <Route path="sem/**/*.html" component={SearchUnitStandaloneLayout} />
    <Route path="*" component={SearchUnitStandaloneLayout} />
    <IndexRoute component={SearchUnitStandaloneLayout} />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes/searchUnit.jsx
 **/